module.exports = __webpack_public_path__ + "images/emoji/clock1130.8f9620588a41ecdba4cd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock1130.png
// module id = U0wE
// module chunks = 24